import { ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { HammerModule } from '@angular/platform-browser';
import { provideRmaInstance } from '@rma/common-ui-ng/instance';
import { provideDeviceIdentification } from '@rma/common-ui-ng/util';
import { Environment, IS_PRODUCTION, provideRmaEnvironment } from '@rma/generic/util/environment';
import { provideRmaMetaPixelRouteTracking } from '@rma/generic/util/tracking/meta-pixel';
import { environment as devEnvironment } from '../environment/environment';
import { commonConfig } from './app.config.common';

declare let environment: Environment;

const env = IS_PRODUCTION ? environment : devEnvironment;

const browserConfig: ApplicationConfig = {
  providers: [
    provideRmaInstance(env.tenantCode, env.type),
    // We can't add this in the app because it breaks ssr
    importProvidersFrom(HammerModule),
    // this overrides the one that is injected from ssr, so we need to make sure it is done only in the browser version
    provideRmaEnvironment(env),
    // This is cookie based, so it can't be loaded on the server
    provideDeviceIdentification(),
    provideRmaMetaPixelRouteTracking(),
  ],
};

export const config = mergeApplicationConfig(commonConfig, browserConfig);

// export const config: ApplicationConfig = {
//   providers: [
//     provideRmaInstance(env.tenantCode, env.type),
//     importProvidersFrom(BrowserCookiesModule.forRoot(), BrowserModule),
//     provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
//     provideAnimations(),
//     importProvidersFrom(Angulartics2Module.forRoot(), AuthenticationShellModule.forRoot()),
//     provideLowerCaseUrlSerializer(),
//     provideMetaInitializer(),
//     // provideRmaAuth(),
//     provideRmaGoogleTracking(),
//     provideRmaHeap(),
//     provideRmaHttpClient(),
//     provideRmaFeatureFlagsBrowser(env.launchDarklyClientId, FeatureFlagUserIdentificationService),
//     provideRmaLocale(),
//     provideRmaMaterial(),
//     provideRmaTrackJs(),
//     provideRmaTranslation(),
//     provideRmaUser(),
//     provideUuidGeneration(),
//     provideRouter(routes, withRouterConfig(routerConfig), withInMemoryScrolling(scrollConfig)),
//     provideClientHydration(
//       withHttpTransferCacheOptions({ includePostRequests: true, includeRequestsWithAuthHeaders: true }),
//       withEventReplay(),
//       withIncrementalHydration(),
//     ),
//     provideCustomImageLoader(),
//     provideHttpClient(
//       withInterceptors([
//         abortErrorInterceptor,
//         errorDecoratorInterceptor,
//         httpCacheInterceptor({ blacklist: ['/v2/users/me', '/users/me/*'], whitelist: ['/reviews/search/withaggregations'] }),
//       ]),
//       withFetch(),
//       withInterceptorsFromDi(),
//     ),
//     // setting up urls
//     provideRmaIdentityUrl(),
//     provideRmaDashboardUrl(),
//     provideRmaImagesUrl(),
//     provideRmaStaticImageUrl(),
//     provideRmaCdnUrl(),
//   ],
// };
